export default __webpack_public_path__ + "static/payments-7db1f98457fc99cc1aa32dfe91281f4e.png";